import React from 'react'
import { Trans } from '@lingui/macro'
import { CheckIcon } from '../icons'

import classes from './ProgressBar.module.scss'

type ProgressBarProps = {
  RADIUS: number
  CIRCUMFERENCE: number
  dashOffset: number
  textColor: string | null
  isReady: boolean
  secondsLeft: number
}

export const ProgressBar = (props: ProgressBarProps) => {
  const { RADIUS, CIRCUMFERENCE, dashOffset, textColor, isReady, secondsLeft } =
    props

  return (
    <div className={classes.TimerWrapper}>
      <svg
        width="180"
        height="180"
        viewBox="0 0 180 180"
        className={classes.TimerSvg}
      >
        <circle
          cx="90"
          cy="90"
          r={RADIUS}
          className={classes.TrackCircle}
          style={
            textColor ? { stroke: textColor, strokeOpacity: 0.2 } : undefined
          }
        />
        <circle
          cx="90"
          cy="90"
          r={RADIUS}
          className={classes.ProgressCircle}
          style={textColor ? { stroke: textColor } : undefined}
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={dashOffset}
        />
      </svg>
      <div className={classes.TimerContent}>
        {isReady ? (
          <>
            <span
              className={classes.Checkmark}
              style={textColor ? { color: textColor } : undefined}
            >
              <CheckIcon />
            </span>
            <span className={classes.ReadyText}>
              <Trans>Ready!</Trans>
            </span>
          </>
        ) : (
          <span className={classes.Seconds}>{secondsLeft}s</span>
        )}
      </div>
    </div>
  )
}
